import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createOrganization } from ".";

export function useCreateOrganization() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: createOrganization,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.organisation._def,
                exact: false
            });
        }
    });
}